"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _lodash = _interopRequireDefault(require("lodash.throttle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var possiblePlacements = ['top', 'right', 'bottom', 'left'];
var tooltipRoot = document.getElementById('tooltip-wrapper');

var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    var eventEmitter = props.eventEmitter; // default state

    _this.state = _objectSpread({
      render: props.render,
      target: props.target,
      placement: 'top',
      className: '',
      margin: 10
    }, props.initialState || {});
    _this.el = document.createElement('div');
    _this.container = /*#__PURE__*/_react.default.createRef();
    _this.attemptedPlacements = [];
    _this.clearTooltip = _this.clearTooltip.bind(_assertThisInitialized(_this));
    _this.toggleTooltip = _this.toggleTooltip.bind(_assertThisInitialized(_this));

    _this.updateTooltip = function (payload) {
      return _this.setState(payload);
    };

    _this.getTooltipState = function () {
      return _this.state;
    };

    if (eventEmitter) {
      // tooltips can be namespaced so multiple can be managed at once
      _this.eventPrefix = props.namespace ? "".concat(props.namespace, ".") : ''; // these are for programmatic control of the tooltip from components

      eventEmitter.on("".concat(_this.eventPrefix, "updateTooltip"), _this.updateTooltip);
      eventEmitter.on("".concat(_this.eventPrefix, "clearTooltip"), _this.clearTooltip);
      eventEmitter.on("".concat(_this.eventPrefix, "toggleTooltip"), _this.toggleTooltip);
      eventEmitter.on("".concat(_this.eventPrefix, "getTooltipState"), _this.getTooltipState);
    }

    return _this;
  }

  _createClass(Tooltip, [{
    key: "bindEvents",
    value: function bindEvents(props) {
      var _this2 = this;

      // tooltip
      this.container.current.addEventListener('click', function (e) {
        try {
          // prevent a click from bubbling up to document and closing tooltip
          // unless it's a link click in which case it does need to go to the document to get handled properly
          if (e.target.tagName.toUpperCase() !== 'A') {
            e.stopPropagation();
          }
        } catch (err) {
          console.error(err);
        }
      });
      this.container.current.addEventListener('mouseenter', function () {
        _this2._isHovering = true;
      });
      this.container.current.addEventListener('mouseleave', function () {
        _this2._isHovering = false;
      });
      this.onWindowResize = (0, _lodash.default)(this.onWindowResize.bind(this), 500);
      window.addEventListener('resize', this.onWindowResize);
    }
  }, {
    key: "clearTooltip",
    value: function clearTooltip() {
      this.setState({
        show: false,
        render: null,
        margin: 10,
        className: ''
      });
    }
  }, {
    key: "toggleTooltip",
    value: function toggleTooltip(params) {
      this.setState(_objectSpread({
        show: !this.state.show
      }, params));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var eventEmitter = this.props.eventEmitter;
      tooltipRoot.removeChild(this.el);
      window.removeEventListener('resize', this.onWindowResize);

      if (eventEmitter) {
        eventEmitter.off("".concat(this.eventPrefix, "updateTooltip"), this.updateTooltip);
        eventEmitter.off("".concat(this.eventPrefix, "clearTooltip"), this.clearTooltip);
        eventEmitter.off("".concat(this.eventPrefix, "toggleTooltip"), this.toggleTooltip);
        eventEmitter.off("".concat(this.eventPrefix, "getTooltipState"), this.getTooltipState);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      tooltipRoot.appendChild(this.el);
      this.arrow = this.container.current.querySelector('.tooltip-arrow');
      this.place();
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      if (this.state.show) {
        this.position();
      }
    }
  }, {
    key: "getTargetCoords",
    value: function getTargetCoords(target, placement) {
      var margin = this.state.margin;

      if (Array.isArray(target) && target.length === 2) {
        switch (placement) {
          case 'top':
            return [target[0], target[1] - margin];

          case 'right':
            return [target[0] + margin, target[1]];

          case 'bottom':
            return [target[0], target[1] + margin];

          case 'left':
            return [target[0] - margin, target[1]];
        }
      }

      if (target instanceof HTMLElement || target instanceof SVGElement) {
        var _target$getBoundingCl = target.getBoundingClientRect(),
            top = _target$getBoundingCl.top,
            right = _target$getBoundingCl.right,
            bottom = _target$getBoundingCl.bottom,
            left = _target$getBoundingCl.left,
            width = _target$getBoundingCl.width,
            height = _target$getBoundingCl.height;

        switch (placement) {
          case 'top':
            return [left + width / 2, top - margin];

          case 'right':
            return [right + margin, top + height / 2];

          case 'bottom':
            return [left + width / 2, bottom + margin];

          case 'left':
            return [left - margin, top + height / 2];
        }
      }
    }
  }, {
    key: "position",
    value: function position() {
      var _this$container$curre;

      var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.placement;
      var target = this.state.target;

      if (!target) {
        return null;
      }

      var _this$getTooltipCoord = this.getTooltipCoords(target, placement),
          x = _this$getTooltipCoord.x,
          y = _this$getTooltipCoord.y,
          arrowOffsetX = _this$getTooltipCoord.arrowOffsetX,
          arrowOffsetY = _this$getTooltipCoord.arrowOffsetY;

      if (this.isOutsideViewport(x, y)) {
        this.attemptedPlacements.push(placement); // try to get a fallback placement

        var fallbackPlacement = this.getFallbackPlacement(placement); // if the fallback placement has already been tried, then just cycle through the possible placements

        if (this.attemptedPlacements.indexOf(fallbackPlacement) > -1) {
          for (var i = 0; i < possiblePlacements.length; i++) {
            var p = possiblePlacements[i];

            if (this.attemptedPlacements.indexOf(p) === -1) {
              return this.position(p);
            }
          }
        } else {
          return this.position(fallbackPlacement);
        }
      }

      this.attemptedPlacements = [];

      (_this$container$curre = this.container.current.classList).remove.apply(_this$container$curre, possiblePlacements);

      this.container.current.classList.add(placement);
      this.container.current.style.transform = "translate(".concat(Math.round(x), "px, ").concat(Math.round(y), "px)");
      this.arrow.style.transform = "translate(".concat(Math.round(arrowOffsetX), "px, ").concat(Math.round(arrowOffsetY), "px)");
    }
  }, {
    key: "getFallbackPlacement",
    value: function getFallbackPlacement(placement) {
      var fallbackPlacement = this.state.fallbackPlacement;

      if (fallbackPlacement) {
        return fallbackPlacement;
      }

      switch (placement) {
        case 'top':
          return 'bottom';

        case 'right':
          return 'left';

        case 'bottom':
          return 'top';

        case 'left':
          return 'right';
      }
    }
  }, {
    key: "isOutsideViewport",
    value: function isOutsideViewport(x, y) {
      var width = this.container.current.offsetWidth;
      var height = this.container.current.offsetHeight;
      return x < window.scrollX || y < window.scrollY || x + width > window.scrollX + window.innerWidth || y + height > window.scrollY + window.innerHeight;
    }
  }, {
    key: "getTooltipCoords",
    value: function getTooltipCoords(target, placement) {
      var x = null,
          y = null,
          arrowOffsetX = 0,
          arrowOffsetY = 0;
      var width = this.container.current.offsetWidth;
      var height = this.container.current.offsetHeight;

      var _this$getTargetCoords = this.getTargetCoords(target, placement),
          _this$getTargetCoords2 = _slicedToArray(_this$getTargetCoords, 2),
          targetX = _this$getTargetCoords2[0],
          targetY = _this$getTargetCoords2[1];

      var checkForHorizontalOffset = function checkForHorizontalOffset() {
        var offset = Math.min(x, window.scrollX);
        offset = offset ? offset : Math.max(x + width - (window.innerWidth + window.scrollX), 0);
        x -= offset;
        arrowOffsetX = offset;
      };

      var checkForVerticalOffset = function checkForVerticalOffset() {
        var offset = Math.min(y, window.scrollY);
        offset = offset ? offset : Math.max(y + height - (window.innerHeight + window.scrollY), 0);
        y -= offset;
        arrowOffsetY = offset;
      };

      switch (placement) {
        case 'top':
          x = targetX - width / 2;
          y = targetY - height;
          checkForHorizontalOffset();
          break;

        case 'bottom':
          x = targetX - width / 2;
          y = targetY;
          checkForHorizontalOffset();
          break;

        case 'right':
          x = targetX;
          y = targetY - height / 2;
          checkForVerticalOffset();
          break;

        case 'left':
          x = targetX - width;
          y = targetY - height / 2;
          checkForVerticalOffset();
          break;
      }

      return {
        x: x + window.scrollX,
        y: y + window.scrollY,
        arrowOffsetX: arrowOffsetX,
        arrowOffsetY: arrowOffsetY
      };
    }
  }, {
    key: "place",
    value: function place() {
      var _this$state = this.state,
          show = _this$state.show,
          target = _this$state.target;

      if (show && target) {
        this.position();
        this.bindEvents();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.place();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          className = _this$state2.className,
          show = _this$state2.show,
          render = _this$state2.render,
          _this$state2$namespac = _this$state2.namespace,
          namespace = _this$state2$namespac === void 0 ? 'global' : _this$state2$namespac;
      var classes = ['tooltip'];

      if (className) {
        classes.push(className);
      }

      if (namespace) {
        classes.push("tooltip-".concat(namespace));
      }

      return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
        ref: this.container,
        className: "".concat(classes.join(' ')),
        style: {
          display: show && render ? 'block' : 'none'
        }
      }, show && typeof render === 'function' && /*#__PURE__*/_react.default.createElement("div", {
        className: "tooltip-content"
      }, render(this.props, this.state)), /*#__PURE__*/_react.default.createElement("div", {
        className: "tooltip-arrow"
      })), this.el);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _props$initialState = props.initialState,
          initialState = _props$initialState === void 0 ? {} : _props$initialState;
      var newState = {};
      ['render', 'target', 'show', 'margin', 'placement'].forEach(function (key) {
        if (initialState.hasOwnProperty(key) && initialState[key] !== state[key]) {
          newState[key] = initialState[key];
        }
      });
      return Object.keys(newState).length ? newState : null;
    }
  }]);

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;